import Swal from "sweetalert2";

export default {
  namespaced: true,
  state: {
    features: [],
    isLoading: false,
    isSaving: false,
  },
  mutations: {
    SET_STATE: (state, obj) => {
      state[`${obj.key}`] = obj.value;
    },
  },
  actions: {
    getFeatureAccess({ commit }) {
      commit("SET_STATE", { key: "isLoading", value: true });
      let vm = this;
      return new Promise((resolve) => {
        return vm.$http.get("settings/feature-access").then(
          (res) => {
            commit("SET_STATE", {
              key: "features",
              value: res.data.data || [],
            });
            commit("SET_STATE", { key: "isLoading", value: false });
            resolve(res.data.data);
          },
          (err) => {
            commit("SET_STATE", { key: "isLoading", value: false });
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text: err?.data?.error?.message || "Something went wrong...",
                icon: "error",
              });
            }
            resolve();
          }
        );
      });
    },

    updateFeatureAccess(
      { commit },
      { featureKey, status, rolloutMode, userIds }
    ) {
      commit("SET_STATE", { key: "isSaving", value: true });
      let vm = this;
      return new Promise((resolve) => {
        return vm.$http
          .put(`settings/feature-access/${featureKey}`, {
            status,
            rollout_mode: rolloutMode,
            user_ids: userIds,
          })
          .then(
            (res) => {
              commit("SET_STATE", {
                key: "features",
                value: res.data.data || [],
              });
              commit("SET_STATE", { key: "isSaving", value: false });
              Swal.fire({
                title: "",
                text: "Feature access updated.",
                icon: "success",
              }).then(() => {
                window.location.reload();
              });
              resolve(res.data.data);
            },
            (err) => {
              commit("SET_STATE", { key: "isSaving", value: false });
              if (!err.accessDenied) {
                Swal.fire({
                  title: "Error",
                  text:
                    err?.data?.error?.message ||
                    err?.data?.message ||
                    "Something went wrong...",
                  icon: "error",
                });
              }
              resolve();
            }
          );
      });
    },
  },
};
